import React from 'react';
import Responsive from 'react-responsive';
import { styled } from 'styled-components';

import { Sizes } from '../../theme/Media.tsx';
import { useTableContext } from './context.tsx';

export interface IMobileLabel {
  $inline?: boolean;
  children?: React.ReactNode;
}

export const Wrapper = styled.p<Pick<IMobileLabel, '$inline'>>`
  margin: ${({ $inline }) => ($inline ? '0 10px 0 0' : '0 0 6px')};
  font-size: 12px;
  line-height: 13px;
  color: ${({ theme }) => theme.colors.grey100_1};
  &:not(:first-child) {
    margin-top: 7px;
  }
`;

const MobileLabel: React.FC<IMobileLabel> = ({ $inline, children }) => {
  const { isCollapsedNav } = useTableContext();
  return (
    <Responsive maxWidth={isCollapsedNav ? Sizes.mdMax : Sizes.lgMax}>
      <Wrapper $inline={$inline}>{children}</Wrapper>
    </Responsive>
  );
};

export default React.memo(MobileLabel);
